import styles from './styles.module.scss';

export function SecondarySidebarItemTooltip({
  showLabel,
  label
}: {
  showLabel: boolean;
  label: string;
}) {
  return (
    <div className='center-flex-row'>
      {showLabel ? <span className={`text-bold ${styles.textBold}`}>{label}</span> : null}
    </div>
  );
}
